
    const p = document.getElementById('prompt');
    const q = new URLSearchParams(location.search);
    const coarse = q.get('mobile') === '1'
      || (q.get('mobile') !== '0' && matchMedia('(pointer: coarse)').matches);
    if (q.get('shot') === '1' || coarse) p.style.display = 'none';
    // Belt and braces for iOS Safari, which still honours these on the document itself.
    document.addEventListener('gesturestart', (e) => e.preventDefault());
    document.addEventListener('dblclick', (e) => e.preventDefault());
    document.addEventListener('pointerlockchange', () => {
      p.classList.toggle('hide', !!document.pointerLockElement);
    });
  